import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { handleReportUsageNotes } from 'src/common/redux/actions';

export function useReportUsageNotes({ usageDetails, dispatch }) {
    useEffectWithErrorLogging(() => {
        if (
            usageDetails?.usageReplenishmentcustomerNotes ||
            usageDetails?.usagecustomerNotes
        ) {
            const prevSavedNotes = [
                {
                    reportUsageNotes:
                        usageDetails?.usagecustomerNotes?.length > 0
                            ? usageDetails?.usagecustomerNotes
                            : [],
                    reportReplenishmentNotes:
                        usageDetails?.usageReplenishmentcustomerNotes?.length > 0
                            ? usageDetails?.usageReplenishmentcustomerNotes
                            : [],
                },
            ];
            dispatch(handleReportUsageNotes(prevSavedNotes));
        }
    }, [usageDetails]);
}
